export default __webpack_public_path__ + "static/media/no_data_found_dashboard.3c8e5cc7.png";